/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// MR - Product Revies + Q&A - 11 Jun '19

function scrollToS(element) {
  window.scroll({
    behavior: 'smooth',
    left: 0,
    top: element.offsetTop
  });
}

if (document.body.classList.contains('template-product')) {

  var revBtn = document.getElementsByClassName('nw-prod-review')[0];

  revBtn.addEventListener('click', function(event) {
    var elm = document.querySelector('.Product__Aside .Collapsible__Button');
    scrollToS(elm);
    if ( elm.getAttribute('aria-expanded') == 'false' ){
      elm.click();
    }
  })

  //

  var qaBtn = document.getElementsByClassName('button-qa')[0];
  var qaPageBool = false;
  const askButton = document.getElementsByClassName('nw-ask-btn')[0];

  if ( productQuestionNumber > 0 ){
    var simPagInt = setInterval(checkSimPag, 50);
  }

  function checkSimPag(){
    var simPagElm = document.getElementsByClassName("simPagination")[0];
    if(typeof(simPagElm) != 'undefined' && simPagElm != null){
      //console.log('Element exists');
      clearInterval(simPagInt);
      if ( !qaPageBool){
        var prev = document.getElementsByClassName('simp-previous')[0];
        var next = document.getElementsByClassName('simp-next')[0];

        prev.textContent = 'PREVIOUS';
        prev.classList.add('Button');
        prev.classList.add('Button--secondary');
        next.textContent = 'NEXT';
        next.classList.add('Button');
        next.classList.add('Button--secondary');

        var pag = document.getElementsByClassName('simPagination')[0];
        pag.appendChild(askButton);

        qaPageBool = true;
      }

    }
  }

}



// MR - Multi Blog - 02 Aug '19
$().jquery
$(document).ready(function(){
  if (document.body.classList.contains('template-index')) {

    var multiBlog = {};
    multiBlog.type = '';
    multiBlog.artNo = 0;
    multiBlog.articles = {};

    $.ajax({
      cache: false,
      url: 'https://111skin.com/pages/multi-blog?view=broad-blog',
      dataType: "xml",
      success: function(data){
        multiBlog.type = $(data).find('type').text();

        $(data).find('article').each(function(i){
          multiBlog.artNo = multiBlog.artNo + 1;
          multiBlog.articles[i] = {};
          multiBlog.articles[i]['title'] = $(this).find('title').text();
          multiBlog.articles[i]['url'] = $(this).find('url').text();
          multiBlog.articles[i]['excerpt'] = $(this).find('excerpt').text();
          multiBlog.articles[i]['image'] = $(this).find('image').text();
          multiBlog.articles[i]['alt'] = $(this).find('alt').text();
          multiBlog.articles[i]['category'] = $(this).find('category').text();
        });

        $('.multi-blog-rec .nw-art-cont').each(function(i){
          if ( multiBlog.articles[i] !== undefined ){
            if ( multiBlog.articles[i].image !== undefined || multiBlog.articles[i].image !== '' ) {
              $(this).find('.ArticleItem__ImageWrapper').css('background-url', multiBlog.articles[i].image);
              $(this).find('.ArticleItem__ImageWrapper').prop('href', multiBlog.articles[i].url);
              $(this).find('.ArticleItem__ImageWrapper > img').prop('src', multiBlog.articles[i].image);
              $(this).find('.ArticleItem__ImageWrapper > img').prop('alt', multiBlog.articles[i].alt);
            } else {
              $(this).find('.ArticleItem__ImageWrapper').css('display', 'none');
            }
            $(this).find('.ArticleItem__Category').text(multiBlog.articles[i].category);
            $(this).find('.ArticleItem__Title').html('<a href="' + multiBlog.articles[i].url + '">' + multiBlog.articles[i].title + '</a>');
            $(this).find('.ArticleItem__Excerpt').text(multiBlog.articles[i].excerpt);
            $(this).find('.ArticleItem__Link').prop('href', multiBlog.articles[i].url);
          } else {
            $(this).css('display', 'none');
          }
        });
      }
    });
  }
});